import {InjectionToken} from '@angular/core';

/**
 * App-wide separator for NUMERIC Danish dates. Unprovided (or '.') keeps the locale default
 * (`dd.MM.yyyy`); '-' renders `dd-MM-yyyy`. ngwebbill provides '-'; other apps leave it unset.
 * Only affects the Danish locale and only all-numeric date formats — spelled-month formats
 * (e.g. DATE_MED "10. jul. 2026") are never rewritten.
 */
export const DANISH_DATE_SEPARATOR = new InjectionToken<'.' | '-'>('DANISH_DATE_SEPARATOR', {
    providedIn: 'root',
    factory: (): '.' | '-' => '.',
});
